/**
 * Properties Store — tracks which item is being edited, active tab
 */
import { createStore } from 'zustand/vanilla';

export type PropertiesTab = 'values' | 'grid' | 'transform';

export interface PropertiesState {
  editingItemId: string | null;
  activeTab: PropertiesTab;
  // Actions
  setEditingItem: (itemId: string | null) => void;
  setActiveTab: (tab: PropertiesTab) => void;
}

export const propertiesStore = createStore<PropertiesState>((set) => ({
  editingItemId: null,
  activeTab: 'values',

  setEditingItem: (itemId) => set({ editingItemId: itemId }),
  setActiveTab: (tab) => set({ activeTab: tab }),
}));
